import React from "react";
import "./src/index.css";
import WidgetData from "./src/data/chart.json";
import { Widget } from "@learningblocks/widgets";

export default function Histogram1(props) {
  return (
    <Widget
      widget={"Histogram4"}
      inline="true"
      visible={props.visible}
      widgetData={WidgetData}
      intro={props.intro}
      i18next={props.i18next}
      //usersnap="//api.usersnap.com/load/ceaa5c16-2d5f-45fd-9a81-2db3617035b5.js"
    />
  );
}
